import { Typography } from '@breetometer/components';
import { ActivityIcon } from 'BreetAssets';
import { extractComputerModel, formatDateAndTime, type IActivityLog, parseDeviceInfo } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';

export const DialogActivityLog = () => {
	const { getModalProps } = useModalApi();

	const modalProps = getModalProps('activityLog') as { metadata: { activityLog: IActivityLog } | undefined };

	const activityLog = modalProps.metadata?.activityLog;

	const model = extractComputerModel(activityLog?.deviceName);

	const deviceInfo = parseDeviceInfo(activityLog?.deviceName);

	return (
		<div className='dialog-activity-log bg-primary-500'>
			<div className='activity-log-header'>
				<ActivityIcon variant={model} />
				<Typography
					as='h6'
					className='color-tertiary-400'
				>
					{deviceInfo.deviceName}
				</Typography>
			</div>

			<div className='activity-list bg-primary-600'>
				<div className='activity-list-item'>
					<Typography
						as='label'
						className='color-primary-100'
					>
						Device brand
					</Typography>
					<Typography className='color-neutral-50'>{deviceInfo.deviceName}</Typography>
				</div>

				<div className='activity-list-item'>
					<Typography
						className='color-primary-100'
						as='label'
					>
						Location
					</Typography>
					<Typography className='color-neutral-50'>{activityLog?.location}</Typography>
				</div>

				<div className='activity-list-item'>
					<Typography
						as='label'
						className='color-primary-100'
					>
						IP Address
					</Typography>
					<Typography className='color-neutral-50'>{activityLog?.ipAddress}</Typography>
				</div>

				<div className='activity-list-item'>
					<Typography
						as='label'
						className='color-primary-100'
					>
						Timezone
					</Typography>
					<Typography className='color-neutral-50'>{activityLog?.timezone}</Typography>
				</div>

				<div className='activity-list-item'>
					<Typography
						as='label'
						className='color-primary-100'
					>
						Date & Time
					</Typography>
					<Typography className='color-neutral-50'>
						{formatDateAndTime(activityLog?.createdAt ?? '').date} {formatDateAndTime(activityLog?.createdAt ?? '').time}
					</Typography>
				</div>
			</div>
		</div>
	);
};
